<template>
	<div class="relative">
		<LoadingOverlay
			v-if="$loadingstore.changing_person_choice || $loadingstore.changing_main_product || $loadingstore.changing_date"
		/>
		<TransitionGroup name="fade" tag="div" class="divide-y divide-gray-200">
			<div
				v-for="(entry, personIndex) in $flowstore.checkout.meta.receipt.persons"
				:key="entry.person_id"
				class="py-6 px-8"
			>
				<h2 class="text-lg pb-3 font-serif">{{ entry.person_name }}</h2>
				<ul class="flex flex-col gap-2 -mx-4">
					<li v-for="item in entry.items" :key="item.item_id">
						<Transition name="fade">
							<PersonChoice :person-id="entry.person_id" :item="item">
								<template v-if="isArrangement(item) && isEnabled" #after-name>
									<ExtraNightInfoTip />
								</template>
							</PersonChoice>
						</Transition>
						<ExtraNightPricing v-if="isArrangement(item) && hasBreakdown" :default-open="personIndex === 0" class="px-4" />
					</li>
				</ul>
			</div>
		</TransitionGroup>
	</div>
</template>

<script lang="ts" setup>
import type { ReceiptProductResource } from '@/api/resources';
import { useExtraNightPricing } from '@/composables/useExtraNightPricing';
import ExtraNightInfoTip from '@/components/receipt/ExtraNightInfoTip.vue';
import ExtraNightPricing from '@/components/receipt/ExtraNightPricing.vue';
import LoadingOverlay from '@/components/LoadingOverlay.vue';
import PersonChoice from '@/components/receipt/PersonChoice.vue';

const { isEnabled, hasBreakdown } = useExtraNightPricing();

const isArrangement = (item: ReceiptProductResource) => item.slot === 'main.product';
</script>
